<div class="rc-radio-image" [class.is-disabled]="disabled" [class.is-error]="error">
  @if (label) {
    <div class="rc-radio-image__label">
      {{ label }}
    </div>
  }
  <div class="rc-radio-image__container">
    @for (item of items; track item.value) {
      <div class="rc-radio-image__item">
        <div (click)="toggle(item)" [id]="'rc-radio-image-' + item.value">
          <div class="circle" [class.active]="value === item.value">
            <app-icon class="radio-icon" [class.is-active]="value === item.value" [name]="item.icon"></app-icon>
          </div>
          <p [class.active]="value === item.value">{{ item.label }}</p>
        </div>
      </div>
    }
  </div>
  @if (error) {
    <span class="rc-radio-image__error">{{ error }}</span>
  }
</div>
